/**
 * 404 와 서버 오류를 가른다. 둘을 같이 다루면 장애가 오타로 보고된다 —
 * 사용자는 있지도 않은 코드 오타를 찾고, 실제 장애는 아무도 모른다.
 *
 * `axios.isAxiosError` 를 안 쓴다: axios 는 `@platform/api-client` 안에만 있고
 * 앱의 직접 의존이 아니라 여기서 import 하면 타입이 안 잡힌다(도움말과 동일).
 */
export function statusOf(error: unknown): number | undefined {
  return (error as { response?: { status?: number } } | null)?.response?.status;
}

/**
 * 서버가 보내는 도메인 오류 코드. 상태 코드만으로는 이유가 갈리지 않는다 —
 * `/pumsem` 의 404 는 "공개된 판이 하나도 없다"(첫 설치) 일 수도 있고 "그
 * 판이 없다"(오타·숨김) 일 수도 있는데, 사용자에게 할 말이 완전히 다르다.
 */
export function codeOf(error: unknown): string | undefined {
  return (error as { response?: { data?: { code?: string } } } | null)?.response
    ?.data?.code;
}

export const PUMSEM_ERROR = {
  NO_PUBLISHED_EDITION: 'PUMSEM_NO_PUBLISHED_EDITION',
  EDITION_NOT_FOUND: 'PUMSEM_EDITION_NOT_FOUND',
  NO_PREVIOUS_EDITION: 'PUMSEM_NO_PREVIOUS_EDITION',
  ITEM_NOT_FOUND: 'PUMSEM_ITEM_NOT_FOUND',
  REVISION_NOT_FOUND: 'PUMSEM_REVISION_NOT_FOUND',
  PAYLOAD_TOO_LARGE: 'COMMON_PAYLOAD_TOO_LARGE',
} as const;
